var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"fillRule":"evenodd","clipRule":"evenodd","d":"M30 0C13.4314 0 0 13.4314 0 30C0 46.5686 13.4314 60 30 60C46.5686 60 60 46.5686 60 30C60 13.4314 46.5686 0 30 0ZM33.127 31.3177V47.6394H26.3738V31.3184H23V25.6938H26.3738V22.317C26.3738 17.7285 28.2788 15 33.6914 15H38.1975V20.6251H35.3809C33.2739 20.6251 33.1345 21.4111 33.1345 22.8782L33.127 25.6932H38.2295L37.6323 31.3177H33.127Z","fill":"white"}));
}

Facebook.defaultProps = {"width":"60","height":"60","viewBox":"0 0 60 60","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
